function scrollReveal() {
    var revealPoint = 5;
    var revealElement = document.querySelectorAll(".animatable");

    for (var i = 0; i < revealElement.length; i++) {

        var windowHeight = window.innerHeight;
        var revealTop = revealElement[i].getBoundingClientRect().top;

        if (revealTop < windowHeight - revealPoint) {
            revealElement[i].classList.add("animated");
            revealElement[i].classList.remove("animatable");
        } else {
            revealElement[i].classList.remove("animated");
            revealElement[i].classList.add("animatable");
        }
    }

    var revealElement = document.querySelectorAll(".animatableInner");

    for (var i = 0; i < revealElement.length; i++) {

        var windowHeight = window.innerHeight;
        var revealTop = revealElement[i].getBoundingClientRect().top;

        if (revealTop < windowHeight - revealPoint) {
            revealElement[i].classList.add("animatedInner");
            revealElement[i].classList.remove("animatableInner");
        } else {
            revealElement[i].classList.remove("animatedInner");
            revealElement[i].classList.add("animatableInner");
        }
    }


}
window.addEventListener("scroll", scrollReveal);
